import styled from 'styled-components';

import {
  Flex,
  SVG,
} from 'web-styled';

const cardElementStyles = `
  display: grid;
  align-items: center;
  padding: 6px 12px;
  font-size: 14px;
  width: 100%;
  height: 38px;
  line-height: 38px;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: inset 0 1px 1px rgba(0,0,0, 0.075);
  color: #333;
`;

interface InputProps {
  hasError?: boolean
}

export const ExpirationDate = styled(Flex).attrs({
  column: true,
  spacing: 5,
}) <InputProps>`
  width: 50%;
  position: relative;

  .card-element {
    ${cardElementStyles};
    max-width: 96px;
    border: ${({ hasError }) => (hasError ? '1px solid #ff560a' : '1px solid #ccc')}
  }

  .error-message {
    display: ${({ hasError }) => (hasError ? '' : 'none')};
    max-width: 180px;
    color: #ff560a;
    font-size: 13px;
    line-height: 18px;
  }
`;

export const CardNumContainer = styled(Flex).attrs({
  column: true,
  spacing: 5,
}) <InputProps>`
  width: 100%;
  position: relative;

  .card-element {
    ${cardElementStyles};
    border: ${({ hasError }) => (hasError ? '1px solid #ff560a' : '1px solid #ccc')}
  }
  .error-message {
    display: ${({ hasError }) => (hasError ? '' : 'none')};
    position: absolute;
    right: 0;
    top: -1px;
    color: #ff560a;
    font-size: 13px;
  }
`;

export const CVVContainer = styled(Flex).attrs({
  grow: 1,
  justify: 'flex-end',
  column: true,
  spacing: 5,
}) <InputProps>`
  max-width: 100px;
  position: relative;

  .card-element {
    ${cardElementStyles};
    border: ${({ hasError }) => (hasError ? '1px solid #ff560a' : '1px solid #ccc')}
  }

  .error-message {
    display: ${({ hasError }) => (hasError ? '' : 'none')};
    position: absolute;
    width: 180px;
    bottom: -17px;
    color: #ff560a;
    font-size: 13px;
    line-height: 18px;
  }
`;

export const LockIcon = styled(SVG.Lock).attrs(
  props => ({
    width: '25px',
    height: '25px',
    fill: props.theme.colors.primary,
  }),
)``;

export const Location = styled(Flex).attrs({
  width: '100%',
})`
  flex-direction: column;

  & > *:not(:first-child) {
    margin-top: 15px;
  }

  @media (min-width: 992px) {
    flex-direction: row;

    & > *:not(:first-child) {
      width: 150px;
      margin-top: 0px;
      margin-left: 30px;
    }
  }
`;

export const AddCardForm = styled(Flex).attrs({
  fillSpace: true,
  column: true,
  spacing: 30,
  justify: 'space-around',
  align: 'center',
  as: 'form',
})`
  padding: 15px 0;

  .card-element {
    width: 100%;
  }
`;
